function importChunk({ selector, path = {}, chunk, args = {} }) {
    const elements = document.querySelectorAll(selector);
    args.selector = selector;
    if (elements.length > 0 && typeof chunk === 'function') {
        chunk(path).then(module => {
            if (typeof module.default === 'function') {
                module.default(elements, args);
            } else {
                console.warn('module does not contain a default function', module);
            }
        });
    }
}

export { importChunk };
